import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import DataTableContainer from './DataTableContainer';
import createBridge from '../createBridge';
import withErrorBoundary from '../withErrorBoundary';
import prepareProps from './utils/prepareProps';

// Optional: extract this into its own module (rowClassifier.js)
const manifestRowClass = (row) => (
  row.mostlyReleased=="True" ? 'row-released' : 'row-not-released'
);

const manifestCartonsRowClass = (row) => (
  row.scanColor
  //"c-scanned"
);

const containers = document.querySelectorAll('.react-table-container');

containers.forEach((container) => {
  const element = container.querySelector('.react-table');

  // Build base props
  const props = prepareProps(element.dataset);

  // Only for the manifests table, inject getRowClassName
  if (element.id === 'manifests-table') {
    props.getRowClassName = manifestRowClass;
  } else if (element.id === 'manifest-cartons-table'){
    props.getRowClassName = manifestCartonsRowClass;
  }

  const { updateState, BridgeComponent } =
    createBridge(DataTableContainer, props);

  ReactDOM.render(
    React.createElement(withErrorBoundary(BridgeComponent)),
    element
  );

  const action = container.querySelector('.react-table-update-props');

  if (action) {
    action.addEventListener('click', (event) => {
      event.preventDefault();

      const filterProps = Array.from(
        container.querySelectorAll('.react-table-prop')
      )
        .map((prop) => {
          const value = (prop.value && prop.dataset.dateOutputFormat)
            ? moment(prop.value, prop.dataset.dateFormat)
                .format(prop.dataset.dateOutputFormat)
            : prop.value;

          return {
            name: prop.name,
            value
          };
        });
      updateState({ filters: filterProps });
    });
  }

  const downloadBtn = container.querySelector('.react-table-download-excel');

  if (downloadBtn) {
    downloadBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const exportUrl = downloadBtn.dataset.exportUrl;

      // Get filters (same logic as update-props)
      const filterProps = Array.from(
        container.querySelectorAll('.react-table-prop')
      ).map((prop) => {
        const value = (prop.value && prop.dataset.dateOutputFormat)
          ? moment(prop.value, prop.dataset.dateFormat)
              .format(prop.dataset.dateOutputFormat)
          : prop.value;

        return {
          name: prop.name,
          value
        };
      });

      // Build GET query string
      const params = new URLSearchParams();
      filterProps.forEach(f => params.append(f.name, f.value));

      // Redirect to Django download view
      window.location.href = `${exportUrl}?${params.toString()}`;
    });
  }

});
